

















































import { Vue, Component, Prop } from 'vue-property-decorator';

import {
  IWidgetSettingsFormData,
  WidgetDevice,
  WidgetPosition
} from '@/models/Widget/settings';

import DeviceMockup from '@/componentsV2/molecules/DeviceMockup/DeviceMockup.vue';
import WebsiteMobilePreview from '@/components/icons/WebsiteMobilePreviewV2.vue';

import WidgetPopover from './WidgetPopover.vue';
import WidgetIcon from './WidgetIcon.vue';
import WidgetWelcomeMessage from './WidgetWelcomeMessage.vue';

type Style = Record<string, string | number>;

@Component({
  components: {
    DeviceMockup,
    WidgetPopover,
    WidgetIcon,
    WebsiteMobilePreview,
    WidgetWelcomeMessage
  }
})
export default class MockupWidgetPreview extends Vue {
  @Prop() widgetConfigProps!: IWidgetSettingsFormData;
  @Prop({ default: 'desktop' }) device?: WidgetDevice;
  @Prop({ default: true }) showPopover?: boolean;
  @Prop({ default: false }) showPopoverOnMobile?: boolean;
  @Prop({ default: false }) mobileSimplePreview?: boolean;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business || !business.logo) return '';

    return business.logo.publicPath.large;
  }

  get websiteAddress() {
    const business = this.businessInfo;

    if (!business || !business.website) return '';

    return business.website;
  }

  get widgetConfigPropsHasValues() {
    const hasValues = Object.keys(this.widgetConfigProps || {}).length;

    return !!hasValues;
  }

  get popoverPosition() {
    if (!this.widgetConfigPropsHasValues) return '';

    return this.widgetConfigProps.placement.positioning;
  }

  get popoverTheme() {
    if (!this.widgetConfigPropsHasValues) return '';

    return this.widgetConfigProps.widgetStyle.color;
  }

  get welcomePlacementStyle() {
    if (!this.widgetConfigPropsHasValues) return {};

    const position = this.widgetConfigProps.placement.positioning;
    if (position === 'bottomLeft') {
      return {
        left: 0
      };
    }

    return {
      right: 0
    };
  }

  get popoverPlacementStyle() {
    if (!this.widgetConfigPropsHasValues || !this.device) return {};

    const position = this.widgetConfigProps.placement.positioning;
    const { horizontally, vertically } = this.widgetConfigProps.placement[
      this.device
    ];
    if (this.device === 'mobile') {
      if (position === 'bottomLeft') {
        return {
          left: `-${horizontally}px`,
          bottom: `-${vertically}px`
        };
      }
      return {
        right: `-${horizontally}px`,
        bottom: `-${vertically}px`
      };
    }

    if (position === 'bottomLeft') {
      return {
        left: 0
      };
    }

    return {
      right: 0
    };
  }

  get positionStyle() {
    if (!this.widgetConfigPropsHasValues || !this.device) return {};

    const currentPlacement = this.widgetConfigProps.placement.positioning;
    const { horizontally, vertically } = this.widgetConfigProps.placement[
      this.device
    ];

    const alignmentMap: Record<WidgetPosition, Style> = {
      bottomRight: {
        right: `${horizontally}px`,
        bottom: `${vertically}px`
      },
      bottomLeft: {
        left: `${horizontally}px`,
        bottom: `${vertically}px`
      }
    };

    if (!alignmentMap[currentPlacement]) return {};

    return alignmentMap[currentPlacement];
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get enablePopover() {
    return true;
  }

  get imagePreview() {
    const { imagePreview } = this.widgetConfigProps;

    if (!imagePreview || this.mobileSimplePreview || !this.device) {
      return '';
    }

    const { desktop, mobile } = imagePreview;

    const imageMap: Record<string, string> = {
      desktop,
      mobile
    };

    return imageMap[this.device];
  }
}
